interface QueryParams {
	code?: string
	state?: string
}

export function parseCognitoQueryParams(query: string): QueryParams {
	const params = {} as QueryParams

	for (const param of query.substring(1).split("&")) {
		const [key, value] = param.split("=")
		if (key === "code" || key === "state") {
			params[key] = value
		}
	}
	return params
}
